import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { FastFieldProps, Field } from 'formik';
import { MenuItem } from '@material-ui/core';

import useStudentsFormKey from '../../../hooks/use-students-form-key';
import Select from 'components/@common/Inputs/Select';
import { StudentFieldProps } from '../../../types';
import { gradeDropdownItems } from 'utilities/grade-util';

export const StudentGradeSelectField: React.FC<StudentFieldProps> = ({ index, touched }) => {
  const { t } = useTranslation('AddStudentsStep');
  const studentsFormKey = useStudentsFormKey();

  return (
    <Field name={`${studentsFormKey}.${index}.gradeLevel`}>
      {({ field, meta }: FastFieldProps): ReactElement => {
        const { value, ...remainingField } = field;
        return (
          <Select
            {...remainingField}
            placeholder={t('Grade')}
            value={value || ''}
            error={Boolean((touched || meta.touched) && meta.error)}
            helperText={(touched || meta.touched) && meta.error}
            inputProps={{
              'aria-label': `${t('Student')} ${index + 1} ${t('Grade')}`
            }}
            size="small"
          >
            {gradeDropdownItems.map(x => (
              <MenuItem value={x.value}>{x.name}</MenuItem>
            ))}
          </Select>
        );
      }}
    </Field>
  );
};
